import React from "react";
import { about, profile } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function About() {
  const { ref, visible } = useReveal();
  return (
    <section id="about" className="py-24 md:py-32 bg-[var(--bg-alt)] scroll-mt-20">
      <div className="container-wide">
        <div ref={ref} className={`grid md:grid-cols-12 gap-12 lg:gap-16 items-start reveal ${visible ? "is-visible" : ""}`}>
          <div className="md:col-span-5">
            <div className="relative overflow-hidden rounded-lg aspect-[4/5] bg-[var(--bg-alt)]">
              <img
                src={about.portrait}
                alt={profile.name}
                className="w-full h-full object-cover object-[50%_18%] mix-blend-multiply"
              />
            </div>
          </div>

          <div className="md:col-span-7">
            <span className="section-label">About</span>
            <h2 className="font-serif-display font-light text-4xl md:text-5xl lg:text-[3.4rem] mt-4 tracking-[0.015em] leading-[1.05] text-balance">
              A designer who cares about the details others miss.
            </h2>
            <div className="mt-8 space-y-5 max-w-xl">
              {about.paragraphs.map((p, i) => (
                <p key={i} className="text-[17px] leading-relaxed text-[var(--muted)]">
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-10">
              <p className="section-label mb-4">Capabilities</p>
              <div className="flex flex-wrap gap-2.5">
                {about.skills.map((skill) => (
                  <span
                    key={skill}
                    className="px-4 py-2 rounded-full border border-[var(--line)] text-[13px] text-[var(--ink)] bg-[#FAFAF7]"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
